import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { PortfolioLoadingService, PortfolioStatsService } from '@services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'summary-card',
  templateUrl: './summary-card.component.html',
  styleUrl: './summary-card.component.scss'
})
export class SummaryCardComponent implements OnInit, OnDestroy {
  isLoading = true;
  startupStudiesCount = 0;
  enrollmentStudiesCount = 0;
  maintenanceStudiesCount = 0;
  closingStudiesCount = 0;

  private subscriptions = new Subscription();

  private portfolioStatsService = inject(PortfolioStatsService);
  private portfolioLoadingService = inject(PortfolioLoadingService);

  ngOnInit(): void {
    this.subscriptions.add(
      this.portfolioLoadingService.isLoading$.subscribe((isLoading) => {
        this.isLoading = isLoading;
      })
    );

    this.subscriptions.add(
      this.portfolioStatsService.startupStudiesCount$.subscribe((count) => {
        this.startupStudiesCount = count;
      })
    );

    this.subscriptions.add(
      this.portfolioStatsService.enrollmentStudiesCount$.subscribe((count) => {
        this.enrollmentStudiesCount = count;
      })
    );

    this.subscriptions.add(
      this.portfolioStatsService.maintenanceStudiesCount$.subscribe((count) => {
        this.maintenanceStudiesCount = count;
      })
    );

    this.subscriptions.add(
      this.portfolioStatsService.closingStudiesCount$.subscribe((count) => {
        this.closingStudiesCount = count;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
